<template>
  <div class="profile-history-wrapper">
    <router-link class="profile-history-backAction" :to="{ name: 'profile' }" ><img src="@/assets/img/left-arrow.svg" alt="Back to profile" />Trở về</router-link>
    <h1 class="profile-history-title">Lịch sử thay đổi</h1>
    <div class="profile-history-table-wrapper">
      <table class="profile-history-table">
        <thead>
          <tr>
            <th>Thông tin chỉnh sửa</th>
            <th>Ngày chỉnh sửa</th>
            <th>Giờ chỉnh sửa</th>
            <th>Thiết bị</th>
            <th>Giá trị trước</th>
            <th>Giá trị sau</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in accountHistories" :key="index">
            <td>{{item.TypeOfInformation}}</td>
            <td>{{ item.UpdatedOn | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</td>
            <td>{{ item.UpdatedOn | dateParse('YYYY-MM-DDTHH:mm:ss') | dateFormat('HH:mm:ss') }}</td>
            <td>{{item.Device}}</td>
            <td>{{item.TypeOfInformation === 'Mật khẩu' ? '********' : item.ValueBefore}}</td>
            <td>{{item.TypeOfInformation === 'Mật khẩu' ? '********' : item.ValueAfter}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <paginate
      :pageCount="pageCount"
      :containerClass="'pagination'"
      :prev-text="'<i class=&quot;iconvl icon-angle-left&quot;></i>'"
      :next-text="'<i class=&quot;iconvl icon-angle-right&quot;></i>'"
      :clickHandler="paginateCallback">
    </paginate>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import Paginate from 'vuejs-paginate'

export default {
  name: 'profileHistoryPage',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  components: {
    Paginate
  },
  computed: {
    ...mapState('accountHistories', {
      accountHistories: 'items',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading'
    }),
    ...mapGetters('accountHistories', [
      'isEmpty'
    ]),
    fetchParams () {
      const pagination = this.prepareFetchParamsMixin({
        pageSize: this.pagination.limit,
        pageIndex: this.pagination.page
      })
      return { ...pagination }
    },
    pageCount () {
      return Math.ceil(this.pagination.total / this.pagination.limit)
    }
  },
  watch: {
    'pagination.limit': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    },
    'pagination.page': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    },
    limit: {
      handler: function (newVal) {
        this.$store.commit('accountHistories/SET_PAGINATION', { limit: newVal })
      },
      immediate: true
    },
    page: {
      handler: function (newVal) {
        this.$store.commit('accountHistories/SET_PAGINATION', { page: newVal })
      },
      immediate: true
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('accountHistories/getListPublic', { params: this.fetchParams })
    },
    paginateCallback: function (page) {
      this.$store.commit('accountHistories/SET_PAGINATION', { page: page })
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style lang="scss" scoped>
  @import '@/scss/components/_profileHistoryTable.scss';
  @import '@/scss/components/_profileEdit.scss';
</style>
